import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_THEME } from '../theme/themeConfig';

export const themeSliceDetails = createSlice({
  name: 'themeSliceDetails',
  initialState: {
    theme: { ...DEFAULT_THEME },
    defaultTheme: { ...DEFAULT_THEME },
  },
  reducers: {
    setTheme: (state, action) => {
      state.theme = { ...state.theme, ...action.payload };
    },
    setDefaultTheme: (state, action) => {
      state.defaultTheme = { ...state.defaultTheme, ...action.payload };
    },
    resetToDefaultTheme: (state) => {
      state.theme = { ...state.defaultTheme };
    },
    hydrateTheme: (state, action) => {
      state.theme = { ...DEFAULT_THEME, ...(action.payload?.theme || {}) };
      state.defaultTheme = { ...DEFAULT_THEME, ...(action.payload?.defaultTheme || {}) };
    },
  },
});

export const { setTheme, setDefaultTheme, resetToDefaultTheme, hydrateTheme } = themeSliceDetails.actions;

export default themeSliceDetails.reducer;
